import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-amber-50 to-rose-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/e4a6c3bc861005ae8b92010084d6bbbd/54f4866cb8ebc76c5320c7302dda471a.jpeg" 
                alt="Rooted & Rising" 
                className="h-10 w-10 object-cover rounded-lg"
              />
              <span className="text-lg font-semibold text-gray-900">Rooted &amp; Rising</span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Building micro-habits that transform families. Rooted in what matters most, rising through small daily actions across Faith, Family, Friends, Fitness, Finances, Food, and Fun.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-amber-600 hover:bg-amber-50 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-amber-600 hover:bg-amber-50 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-amber-600 hover:bg-amber-50 transition-colors cursor-pointer">
                <i className="ri-pinterest-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-amber-600 hover:bg-amber-50 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/how-it-works" className="text-sm text-gray-600 hover:text-amber-600 transition-colors">How It Works</Link></li>
              <li><Link to="/pillars" className="text-sm text-gray-600 hover:text-amber-600 transition-colors">Seven Pillars</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-600 hover:text-amber-600 transition-colors">Blog</Link></li>
              <li><Link to="/store" className="text-sm text-gray-600 hover:text-amber-600 transition-colors">Store</Link></li>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-amber-600 transition-colors">About Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">The Seven Pillars</h4>
            <ul className="space-y-3">
              <li><span className="text-sm text-gray-600">Faith</span></li>
              <li><span className="text-sm text-gray-600">Family</span></li>
              <li><span className="text-sm text-gray-600">Friends</span></li>
              <li><span className="text-sm text-gray-600">Fitness</span></li>
              <li><span className="text-sm text-gray-600">Finances</span></li>
              <li><span className="text-sm text-gray-600">Food</span></li>
              <li><span className="text-sm text-gray-600">Fun</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">© 2024 Rooted &amp; Rising. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-amber-600 transition-colors mt-4 md:mt-0">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}